<v-container fluid class="fill-height login-bg">
    <v-row justify="center" class="w-100 ma-0">
        <v-col cols="12" sm="8" md="4" style="max-width: 360px;">
            <div class="text-center mb-6">
                <v-img :src="require('@/assets/logo.svg')" width="56" height="56" class="mx-auto mb-3" />
                <div class="text-h6 font-weight-bold">Statistiche</div>
                <div class="text-body-2 text-medium-emphasis">Accedi al sistema</div>
            </div>
            <v-form ref="formLogin" @submit.prevent="submit()">
                <v-card class="pa-2 pt-1" elevation="3">
                    <v-card-text class="mt-2 pb-0">
                        <v-text-field prepend-inner-icon="mdi-account" label="Utente" v-model="cred.username"
                            :rules="[() => cred.username.length > 0 || 'Il campo utente è obbligatorio']" autofocus
                            required />
                        <v-text-field prepend-inner-icon="mdi-lock" label="Password" v-model="cred.password"
                            :rules="[() => cred.password.length > 0 || 'Il campo password è obbligatorio']"
                            :type="e1 ? 'password' : 'text'" :append-inner-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append-inner="e1 = !e1" required />
                    </v-card-text>
                    <v-card-actions class="px-4 pb-4">
                        <v-btn block color="primary" variant="flat" type="submit" :disabled="attesa" :loading="attesa">
                            Accedi
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-col>
    </v-row>
</v-container>
